export default __webpack_public_path__ + "adbd872d95a100cf98c69de5a28f0304.png";